import { Column, Columns, Container } from '@codeparva/ui-components-library';
import React from 'react';
import { UnitCard } from '../../../../components/unitDetailsCard/UnitCard';
import { Accordion } from './Accordian';
import { ConfirmationTypes } from './ConfirmationTypes';

export const ConfirmationSection = ({
  confirmationSectionConfig,
  tenantToken,
  facPublicKey,
}: ConfirmationTypes.TConfirmationComponent) => {
  const pathName =
    location.pathname
      .replace(/\/+$/, '')
      .split('/')
      .pop() ?? '';
  const gatsbyPathName = pathName;
  const ShowAccordion = () => {
    const accordionData = {
      ...confirmationSectionConfig,
      contentArr: confirmationSectionConfig.sections,
      theme: confirmationSectionConfig.theme,
    };
    return <Accordion {...accordionData} />;
  };

  return (
    <Container className="confirmationPageContainer m-0 pt-0">
      <Columns className="confirmationPageColumns">
        <Column className="confirmationPageColumnOne">
          <h4 className="confirmationPageTitle has-text-text">
            {confirmationSectionConfig.heading}
          </h4>
          <ShowAccordion />
        </Column>
        <Column className="confirmationPageColumnTwo">
          <UnitCard
            unitsData={confirmationSectionConfig.unitsData}
            individualUnitTypeData={
              confirmationSectionConfig.individualUnitsData
            }
            unitCardsConfig={confirmationSectionConfig.unitCardsConfig}
            isConfirmationPage={true}
            onSetIndividualData={() => {}}
            path={pathName}
            gatsbyPathName={gatsbyPathName}
            facilityId={confirmationSectionConfig.facilityId}
            ledgerId={confirmationSectionConfig.ledgerId}
            tenantToken={tenantToken}
            facPublicKey={facPublicKey}
          />
        </Column>
      </Columns>
    </Container>
  );
};
